/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type articlePage_article$ref: FragmentReference;
export type articlePage_article = {|
  +publishedAt: ?string,
  +slug: ?string,
  +title: ?string,
  +forceTitleToAppearUnderneath: ?boolean,
  +caption: ?string,
  +readingTime: ?number,
  +picture: ?string,
  +widePicture: ?string,
  +videoLink: ?string,
  +author: ?{|
    +firstname: ?string,
    +lastname: ?string,
    +biography: ?string,
    +picture: ?string,
    +facebook: ?string,
    +twitter: ?string,
    +instagram: ?string,
    +linkedin: ?string,
    +website: ?string,
  |},
  +sponsor: ?{|
    +name: ?string,
    +description: ?string,
    +logo: ?string,
  |},
  +city: ?{|
    +slug: string,
    +name: string,
    +color: ?string,
    +articles: $ReadOnlyArray<{|
      +slug: ?string,
      +title: ?string,
      +caption: ?string,
      +readingTime: ?number,
      +picture: ?string,
      +author: ?{|
        +firstname: ?string,
        +lastname: ?string,
      |},
    |}>,
  |},
  +cities: ?$ReadOnlyArray<?{|
    +slug: string,
    +name: string,
    +color: ?string,
    +articles: $ReadOnlyArray<{|
      +slug: ?string,
      +title: ?string,
      +caption: ?string,
      +readingTime: ?number,
      +picture: ?string,
      +author: ?{|
        +firstname: ?string,
        +lastname: ?string,
      |},
    |}>,
  |}>,
  +category: ?{|
    +slug: ?string,
    +name: ?string,
    +color: ?string,
    +articles: $ReadOnlyArray<{|
      +slug: ?string,
      +title: ?string,
      +caption: ?string,
      +readingTime: ?number,
      +picture: ?string,
      +author: ?{|
        +firstname: ?string,
        +lastname: ?string,
      |},
    |}>,
  |},
  +slices: $ReadOnlyArray<{|
    +type: ?string,
    +intro: ?{|
      +initialLetter: ?string,
      +text: ?string,
      +hyperlink_content: ?$ReadOnlyArray<?{|
        +type: ?string,
        +text: ?string,
        +spans: ?$ReadOnlyArray<{|
          +data: ?{|
            +id: ?string,
            +uid: ?string,
            +url: ?string,
            +type: ?string,
            +slug: ?string,
            +link_type: ?string,
          |},
          +start: number,
          +end: number,
          +type: string,
        |}>,
        +label: ?string,
      |}>,
    |},
    +pictureDuo: $ReadOnlyArray<{|
      +picture: ?string,
      +caption: ?string,
    |}>,
    +inlinePicture: ?{|
      +picture: ?string,
      +caption: ?string,
    |},
    +highlightedPicture: ?{|
      +picture: ?string,
      +caption: ?string,
    |},
    +quote: ?string,
    +embed: ?string,
    +paragraph: $ReadOnlyArray<{|
      +type: ?string,
      +text: ?string,
      +spans: ?$ReadOnlyArray<{|
        +start: number,
        +end: number,
        +type: string,
        +data: ?{|
          +id: ?string,
          +uid: ?string,
          +type: ?string,
          +slug: ?string,
          +link_type: ?string,
          +url: ?string,
        |},
      |}>,
    |}>,
    +textPicture: ?{|
      +picture: ?string,
      +content: ?$ReadOnlyArray<?{|
        +type: ?string,
        +text: ?string,
        +label: ?string,
        +spans: ?$ReadOnlyArray<{|
          +data: ?{|
            +id: ?string,
            +uid: ?string,
            +type: ?string,
            +slug: ?string,
            +url: ?string,
            +link_type: ?string,
          |},
          +start: number,
          +end: number,
          +type: string,
        |}>,
      |}>,
    |},
  |}>,
  +seo: ?{|
    +title: ?string,
    +description: ?string,
  |},
  +social: ?{|
    +twitter: ?$ReadOnlyArray<?{|
      +type: ?string,
      +title: ?string,
      +image: ?string,
      +handle: ?string,
      +description: ?string,
    |}>,
    +generic: ?$ReadOnlyArray<?{|
      +title: ?string,
      +image: ?string,
      +description: ?string,
    |}>,
  |},
  +$refType: articlePage_article$ref,
|};
*/


const node/*: ConcreteFragment*/ = (function(){
var v0 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "slug",
  "args": null,
  "storageKey": null
},
v1 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "title",
  "args": null,
  "storageKey": null
},
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "caption",
  "args": null,
  "storageKey": null
},
v3 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "readingTime",
  "args": null,
  "storageKey": null
},
v4 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "picture",
  "args": null,
  "storageKey": null
},
v5 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "firstname",
  "args": null,
  "storageKey": null
},
v6 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "lastname",
  "args": null,
  "storageKey": null
},
v7 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "name",
  "args": null,
  "storageKey": null
},
v8 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "description",
  "args": null,
  "storageKey": null
},
v9 = [
  v0,
  v7,
  {
    "kind": "ScalarField",
    "alias": null,
    "name": "color",
    "args": null,
    "storageKey": null
  },
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "articles",
    "storageKey": "articles(first:7)",
    "args": [
      {
        "kind": "Literal",
        "name": "first",
        "value": 7,
        "type": "Int"
      }
    ],
    "concreteType": "Article",
    "plural": true,
    "selections": [
      v0,
      v1,
      v2,
      v3,
      v4,
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "author",
        "storageKey": null,
        "args": null,
        "concreteType": "Author",
        "plural": false,
        "selections": [
          v5,
          v6
        ]
      }
    ]
  }
],
v10 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "type",
  "args": null,
  "storageKey": null
},
v11 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "text",
  "args": null,
  "storageKey": null
},
v12 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v13 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "uid",
  "args": null,
  "storageKey": null
},
v14 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "url",
  "args": null,
  "storageKey": null
},
v15 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "link_type",
  "args": null,
  "storageKey": null
},
v16 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "start",
  "args": null,
  "storageKey": null
},
v17 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "end",
  "args": null,
  "storageKey": null
},
v18 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "label",
  "args": null,
  "storageKey": null
},
v19 = [
  v4,
  v2
],
v20 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "image",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Fragment",
  "name": "articlePage_article",
  "type": "Article",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "publishedAt",
      "args": null,
      "storageKey": null
    },
    v0,
    v1,
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "forceTitleToAppearUnderneath",
      "args": null,
      "storageKey": null
    },
    v2,
    v3,
    v4,
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "widePicture",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "videoLink",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "author",
      "storageKey": null,
      "args": null,
      "concreteType": "Author",
      "plural": false,
      "selections": [
        v5,
        v6,
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "biography",
          "args": null,
          "storageKey": null
        },
        v4,
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "facebook",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "twitter",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "instagram",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "linkedin",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "website",
          "args": null,
          "storageKey": null
        }
      ]
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "sponsor",
      "storageKey": null,
      "args": null,
      "concreteType": "Partner",
      "plural": false,
      "selections": [
        v7,
        v8,
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "logo",
          "args": null,
          "storageKey": null
        }
      ]
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "city",
      "storageKey": null,
      "args": null,
      "concreteType": "City",
      "plural": false,
      "selections": v9
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "cities",
      "storageKey": null,
      "args": null,
      "concreteType": "City",
      "plural": true,
      "selections": v9
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "category",
      "storageKey": null,
      "args": null,
      "concreteType": "Category",
      "plural": false,
      "selections": v9
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "slices",
      "storageKey": null,
      "args": null,
      "concreteType": "ArticleSlice",
      "plural": true,
      "selections": [
        v10,
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "intro",
          "storageKey": null,
          "args": null,
          "concreteType": "ArticleIntro",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "initialLetter",
              "args": null,
              "storageKey": null
            },
            v11,
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "hyperlink_content",
              "storageKey": null,
              "args": null,
              "concreteType": "ArticleText",
              "plural": true,
              "selections": [
                v10,
                v11,
                {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "spans",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "ArticleTextSpan",
                  "plural": true,
                  "selections": [
                    {
                      "kind": "LinkedField",
                      "alias": null,
                      "name": "data",
                      "storageKey": null,
                      "args": null,
                      "concreteType": "ArticleTextSpanData",
                      "plural": false,
                      "selections": [
                        v12,
                        v13,
                        v14,
                        v10,
                        v0,
                        v15
                      ]
                    },
                    v16,
                    v17,
                    v10
                  ]
                },
                v18
              ]
            }
          ]
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "pictureDuo",
          "storageKey": null,
          "args": null,
          "concreteType": "ArticleInlinePicture",
          "plural": true,
          "selections": v19
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "inlinePicture",
          "storageKey": null,
          "args": null,
          "concreteType": "ArticleInlinePicture",
          "plural": false,
          "selections": v19
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "highlightedPicture",
          "storageKey": null,
          "args": null,
          "concreteType": "ArticleInlinePicture",
          "plural": false,
          "selections": v19
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "quote",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "embed",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "paragraph",
          "storageKey": null,
          "args": null,
          "concreteType": "ArticleText",
          "plural": true,
          "selections": [
            v10,
            v11,
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "spans",
              "storageKey": null,
              "args": null,
              "concreteType": "ArticleTextSpan",
              "plural": true,
              "selections": [
                v16,
                v17,
                v10,
                {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "data",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "ArticleTextSpanData",
                  "plural": false,
                  "selections": [
                    v12,
                    v13,
                    v10,
                    v0,
                    v15,
                    v14
                  ]
                }
              ]
            }
          ]
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "textPicture",
          "storageKey": null,
          "args": null,
          "concreteType": "ArticleTextPic",
          "plural": false,
          "selections": [
            v4,
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "content",
              "storageKey": null,
              "args": null,
              "concreteType": "ArticleText",
              "plural": true,
              "selections": [
                v10,
                v11,
                v18,
                {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "spans",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "ArticleTextSpan",
                  "plural": true,
                  "selections": [
                    {
                      "kind": "LinkedField",
                      "alias": null,
                      "name": "data",
                      "storageKey": null,
                      "args": null,
                      "concreteType": "ArticleTextSpanData",
                      "plural": false,
                      "selections": [
                        v12,
                        v13,
                        v10,
                        v0,
                        v14,
                        v15
                      ]
                    },
                    v16,
                    v17,
                    v10
                  ]
                }
              ]
            }
          ]
        }
      ]
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "seo",
      "storageKey": null,
      "args": null,
      "concreteType": "SEO",
      "plural": false,
      "selections": [
        v1,
        v8
      ]
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "social",
      "storageKey": null,
      "args": null,
      "concreteType": "SocialMedia",
      "plural": false,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "twitter",
          "storageKey": null,
          "args": null,
          "concreteType": "TwtrSlices",
          "plural": true,
          "selections": [
            v10,
            v1,
            v20,
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "handle",
              "args": null,
              "storageKey": null
            },
            v8
          ]
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "generic",
          "storageKey": null,
          "args": null,
          "concreteType": "GenSocialSlices",
          "plural": true,
          "selections": [
            v1,
            v20,
            v8
          ]
        }
      ]
    }
  ]
};
})();
// prettier-ignore
(node/*: any*/).hash = '082ebbc93c266377e27b5a299944b62b';
module.exports = node;
